import { ref } from 'vue';
import { defineStore } from 'pinia';

import type { TripPlannerQueryParams } from '../models/navigation';

// NOTE:
// Purpose of this store is to hold parsed, globally available query params

export const useQueryParamsStore = defineStore('QueryParamsStore', () => {
  // State
  const queryParams = ref<TripPlannerQueryParams>();

  // Actions
  function setQueryParams(newQueryParams: TripPlannerQueryParams): void {
    queryParams.value = newQueryParams;
  }

  return {
    // State
    queryParams,

    // Actions
    setQueryParams,
  };
});
